import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { PageLoader } from 'junto-ui';
import { LOGOUT } from '@plataforma/utils';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

const Logout = () => {
  useEffect(() => {
    localStorage.clear();

    Cookies.set(LOGOUT, true, {
      domain: process.env.REACT_APP_DOMAIN
    });

    window.location = `${getSessionItem('PLATAFORMA_URL')}logout`;
  }, []);

  return <PageLoader />;
};

export default Logout;
